export default __webpack_public_path__ + "static/icon-seller-47aeed9f266b3ba3e371f4d0ce29873e.png";